// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"2998c739","123":"e5646d9b","156":"4ed301f0","642":"436fcac2"}[chunkId] + ".chunk.js";
};